var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06926 2.51168C4.92677 2.34558 4.71885 2.25 4.50001 2.25C4.28118 2.25 4.07325 2.34558 3.93077 2.51168L1.43077 5.42596C1.16107 5.74035 1.1973 6.21384 1.51169 6.48353C1.82608 6.75322 2.29957 6.71699 2.56926 6.40261L3.75001 5.02619V18.9738L2.56926 17.5974C2.29957 17.283 1.82608 17.2468 1.51169 17.5165C1.1973 17.7862 1.16107 18.2597 1.43077 18.574L3.93077 21.4883C4.07325 21.6544 4.28118 21.75 4.50001 21.75C4.71885 21.75 4.92677 21.6544 5.06926 21.4883L7.56926 18.574C7.83895 18.2597 7.80272 17.7862 7.48834 17.5165C7.17395 17.2468 6.70046 17.283 6.43077 17.5974L5.25001 18.9738V5.02619L6.43077 6.40261C6.70046 6.71699 7.17395 6.75322 7.48834 6.48353C7.80272 6.21384 7.83895 5.74035 7.56926 5.42596L5.06926 2.51168Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2093 3.75619C17.1052 3.45334 16.8203 3.25 16.5 3.25C16.1798 3.25 15.8949 3.45334 15.7907 3.75619L10.2907 19.7562C10.1561 20.1479 10.3645 20.5746 10.7562 20.7093C11.1479 20.8439 11.5746 20.6355 11.7093 20.2438L13.3686 15.4167H19.6314L21.2907 20.2438C21.4254 20.6355 21.8521 20.8439 22.2438 20.7093C22.6355 20.5746 22.8439 20.1479 22.7093 19.7562L17.2093 3.75619ZM16.5 6.30713L19.1158 13.9167H13.8842L16.5 6.30713Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/height.9c6dea73b3ffee5335e990c421913988.svg";
export { ForwardRef as ReactComponent };